import { render, staticRenderFns } from "./ReminderSendModalCard.vue?vue&type=template&id=e02462c0"
import script from "./ReminderSendModalCard.vue?vue&type=script&lang=ts"
export * from "./ReminderSendModalCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e02462c0')) {
      api.createRecord('e02462c0', component.options)
    } else {
      api.reload('e02462c0', component.options)
    }
    module.hot.accept("./ReminderSendModalCard.vue?vue&type=template&id=e02462c0", function () {
      api.rerender('e02462c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sales/ReminderSendModalCard.vue"
export default component.exports